import { LOCAL_STORAGE_KEYS, setStorageValue } from "@/hooks/localstorage";
import { OnboardingForm } from "@/pages/Onboarding/Components/OnboardingForm";
import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";

export const Onboarding: FC = () => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  setStorageValue(LOCAL_STORAGE_KEYS.isNewUser, true);

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "max-content",
        minHeight: "100vh",
        padding: sm ? "0" : "80px",
        overflowY: "auto",
        backgroundColor: (theme: Theme) => theme.surface.normal
      }}
    >
      <OnboardingForm />
    </Box>
  );
};
